import {
  LIST_EXPENSES,
  CREATE_EXPENSE,
  UPDATE_EXPENSE,
} from '@/data/actions/modules/general';

export default [
  {
    path: '/clinical/expenses',
    component: () => import(/* webpackChunkName: "expenses" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_EXPENSES,
    },
  },
  {
    path: '/clinical/expenses/create',
    component: () => import(/* webpackChunkName: "expenses" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_EXPENSE,
    },
  },
  {
    path: '/clinical/expenses/:id/edit',
    component: () => import(/* webpackChunkName: "expenses" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_EXPENSE,
    },
  },
];
